<script setup lang="ts">
  import { ComboboxAnchor, type ComboboxAnchorProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    ComboboxAnchorProps & { class?: HTMLAttributes['class'] }
  >()
</script>

<template>
  <ComboboxAnchor
    data-slot="combobox-anchor"
    :class="cn('relative flex items-center', props.class)"
    v-bind="{ ...$attrs, asChild: props.asChild, as: props.as }"
  >
    <slot />
  </ComboboxAnchor>
</template>
